import { MoreVerticalIcon } from "lucide-react";
import React from "react";
import { DataManActionButton } from "../../components/DataManActionButton";
import { useDataMan } from "../../hooks/useDataMan";

export const DataManRowActions: React.FC = () => {
  const { actions, maxActionButtons = 0 } = useDataMan();

  // Filter to only show inline actions
  const inlineActions = React.useMemo(() => {
    return (actions || []).filter((action) => action.allowInline !== false);
  }, [actions]);

  const sanitizedActions = JSON.stringify(inlineActions);

  const _actions = React.useMemo(() => {
    if (!inlineActions || inlineActions.length === 0) return [];
    if (inlineActions.length <= maxActionButtons) {
      return inlineActions.map((action, index) => {
        return <DataManActionButton key={String(index)} action={action} />;
      });
    }

    return (
      <DataManActionButton
        action={{
          id: "more-actions",
          label: "Actions",
          icon: MoreVerticalIcon,
          subs: inlineActions
        }}
      />
    );
  }, [sanitizedActions, maxActionButtons]);

  return <div className={"flex items-center gap-2"}>{_actions}</div>;
};
